import { useTranslation } from '@klv/hooks/useTranslation';

import TwoColumn from '@klv/organisms/two-column';

import type { ITwoColumn, TBody } from '@klv/organisms/two-column/types';


const MaxContacts = ({ mixedMedia, ...props }: ITwoColumn) => {
  const { t } = useTranslation();

  const body: TBody[] = [
    {
      backgroundColor: 'light',
      bodyType: 'RichText',
      formId: '',
      quote: '',
      richText: t('organisms_pricing_maxContacts_richTextBody'),
    },
  ];
  
  const buttons =  [{
    text:`${t('organisms_pricing_maxContacts_buttons_getDemo')}`,
    url: '/demo-request',
  },
  {
    text: 'sales@klaviyo.com',
    url: 'mailto:sales@klaviyo.com',
  }];
  
  return (
    <TwoColumn
      backgroundColor="light"
      body={body}
      buttons={buttons}
      headline={t('organisms_pricing_maxContacts_headline')}
      mediaAlignment="right"      
      {...props}
    />
  );
};

export default MaxContacts;
